$(document).ready(function(){
  // Add smooth scrolling to all links
  $("#scroll-to-contact, #scroll-to-contact2").on('click', function(event) {
    console.log('yes');
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 1500, function(){
   
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });


  //buying guide sidebar
  $("li.buying-guide-sidebar-section").click(function() {
    $(".buying-guide-sidebar-dropdown").slideUp();
    $(this).find(".buying-guide-sidebar-dropdown").slideToggle();
    $("li.buying-guide-sidebar-section > a").preventDefault();
  });

  //faq page

    $('.faq-question').click(function(){

      //Expand or collapse this panel
      $(this).next().slideToggle('fast');

      //Hide the other panels
      $(".faq-answer").not($(this).next()).slideUp('fast');
      
      // plus minus toggle      
      $(this).find("span.faq-question-plus").toggle();
      $(this).find("span.faq-question-minus").toggle();

      $("span.faq-question-plus").not($(this).find("span.faq-question-plus")).show();
      $("span.faq-question-minus").not($(this).find("span.faq-question-minus")).hide();


    });


    //careers page
    $("p.position-description-more").click(function(){
      $(this).hide();
      $(this).next().show();
    })
    $("p.position-description-less").click(function(){
      $(this).parent().hide();
      $(this).parent().prev().show();
      // $("p.position-description-more").show();
    })    



});